// extracted by mini-css-extract-plugin
module.exports = {"item":"_2KaYSdjYRpI02-1GQGUJIx","link":"_3njNUrkI3BtdsstFrjStyI","icon":"_3lJ7UkufT3mVOJc4J8RGnw"};